export * from '@discoverer/fuse/components/fullscreen/public-api';
